export const navigateToHelpScreen = (context) => {
  let url = '/admin/help';
  if (context) {
    url += '?entity=' + context;
  }
  window.open(url);
  };